<template>
	<tr class="table__row">
		<td class="table__col">
			<span class="table__col-label">№</span>
			<span class="table__col-cont">{{ tender.id }}</span>
		</td>
		<td class="table__col">
			<span class="table__col-label">Товарные категории</span>
			<span class="table__col-cont">{{ tender.productGroups }}</span>
		</td>
		<td class="table__col table__col--baseline">
			<span class="table__col-label">Ответственный МОЗ</span>
			<div class="table__col-cont">
				<div class="table__col-manager">
					<InputSelect>
						<template #select>
							<Multiselect
								v-model="selectedManager"
								:options="tender.managers"
								:label="'name'"
								:value-prop="'id'"
								:can-clear="false"
								:can-deselect="false"
								:no-results-text="'Не найдено'"
								:no-options-text="'Нет данных'"
								searchable
								class="multiselect--table"
							/>
						</template>
					</InputSelect>
				</div>
			</div>
		</td>
		<td class="table__col table__col--baseline">
			<span class="table__col-label">Ответственный УК</span>
			<div class="table__col-cont">
				<div class="table__col-manager">
					<InputSelect>
						<template #select>
							<Multiselect
								v-model="selectedCategoryAdmin"
								:options="tender.categoryAdmins"
								:label="'name'"
								:value-prop="'id'"
								:can-clear="false"
								:can-deselect="false"
								:no-results-text="'Не найдено'"
								:no-options-text="'Нет данных'"
								searchable
								class="multiselect--table"
							/>
						</template>
					</InputSelect>
				</div>
			</div>
		</td>
		<td class="table__col table__col--baseline">
			<span class="table__col-label">Ответственный МК</span>
			<div class="table__col-cont">
				<div class="table__col-manager">
					<InputSelect>
						<template #select>
							<Multiselect
								v-model="selectedCategoryManager"
								:options="tender.categoryManagers"
								:label="'name'"
								:value-prop="'id'"
								:can-clear="false"
								:can-deselect="false"
								:no-results-text="'Не найдено'"
								:no-options-text="'Нет данных'"
								searchable
								class="multiselect--table"
							/>
						</template>
					</InputSelect>
				</div>
			</div>
		</td>
		<td class="table__col">
			<span class="table__col-label">Периодичность</span>
			<div class="table__col-cont">
				<span class="table__col-periodicity">{{ tender.period }}</span>
			</div>
		</td>
		<td class="table__col">
			<span class="table__col-label">Даты</span>
			<div class="table__col-cont">
				<div class="table__col-dates">
					<template v-for="(date, i) in tender.auctionDates.slice(0, 3)" :key="i">
						<a v-if="date.tenderId" class="table__col-cont table__col-cont--green" :href="`/personal/tenders/?ID=${date.tenderId}`" :title="`Перейти на тендер № ${date.tenderId}`" target="_blank" ><b>{{ date.date }}</b></a>
						<span v-else class="table__col-dates-date">{{ date.date  }}</span>
					</template>

				</div>
			</div>
		</td>
		<td class="table__col table__col--btn table__col--relative">
			<a :href="tender.detailUrl" class="link">Подробнее</a>
		</td>
	</tr>
	<tr class="table__margin">
		<td colspan="100%"></td>
	</tr>
</template>

<script>
// import {mapActions, mapGetters} from "vuex";

import InputSelect from "@/components/base/utils/formElements/InputSelect.vue";
import Multiselect from "@vueform/multiselect/src/Multiselect";

export default {
	name: "SchedulesTableRow",
	components: {InputSelect, Multiselect},
	props: {
		tender: {
			type: Object,
			required: true
		}
	},
	data: () => {
		return {
			selectedCategoryAdmin: '',
			selectedCategoryManager: '',
			selectedManager: '',
		}
	},
	computed: {
		selectedCategoryAdminEmail() {
			return this.tender.categoryAdmins?.find(admin => +admin.id === +this.selectedCategoryAdmin)?.email || ''
		},
		selectedCategoryManagerEmail() {
			return this.tender.categoryManagers?.find(manager => +manager.id === +this.selectedCategoryManager)?.email || ''
		},
		selectedManagerEmail() {
			return this.tender.managers?.find(manager => +manager.id === +this.selectedManager)?.email || ''
		}
	},
	created() {
		this.fillManagers();
	},
	methods: {
		fillManagers() {
			this.selectedCategoryAdmin = this.tender.categoryAdmins[0]?.id || '';
			this.selectedCategoryManager = this.tender.categoryManagers[0]?.id || '';
			this.selectedManager = this.tender.managers[0]?.id || '';
		}
	}

}
</script>


